type TypeDownloader = {
  blob: Blob
  serverFilename?: string
  defaultName?: string
  fileExtension?: 'xlsx' | 'zip' | 'pdf'
}

const fallbackName = 'virbac-es_file'

/**
 * Download XLS file
 * @param {Blob} blob - The blob object to download
 * @param {string} serverFilename - The filename to use when saving the file, (extension INCLUDED)
 * @param {string} defaultName - The default name to use if serverFilename is not provided (WITHOUT extension)
 * @param {string} fileExtension - The file extension to use (default is 'xlsx')
**/
export const blobDownloader = async ({ blob, serverFilename, defaultName = '', fileExtension = 'xlsx' }: TypeDownloader) => {
  // Uncomment if the response doesn't have set the proper 'Accept' header type
  // It is necessary to create a new blob object with mime-type explicitly set
  // var newBlob = new Blob([blob], { type: 'application/vnd.ms-excel' })

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  // @ts-expect-error - msSaveOrOpenBlob is only present in old IE browsers
  if (window.navigator?.msSaveOrOpenBlob) {
    // @ts-expect-error - msSaveOrOpenBlob is only present in old IE browsers
    window.navigator.msSaveOrOpenBlob(blob)
    return
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = data
  link.download = serverFilename ?? `${defaultName ? defaultName : fallbackName}.${fileExtension}`
  link.click()
  setTimeout(function() {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data)
  }, 100)
}
